export default __webpack_public_path__ + "static/media/partner-banner.268a7366.webp";